module.exports = __webpack_public_path__ + "img/ec.0b6d7132.svg";